// First Created - 04 Jun 2025
// Author - Atul Pandey

export const TRINITY_INSIGHT_PROMPTS = [
  {
    id: 'nextConversation',
    label: 'What should be my next conversation with this contact?',
  },
  {
    id: 'suggestedActions',
    label: 'What actions can I take from this conversation?',
  },
  {
    id: 'whoElseToInvolve',
    label: 'Who else should I involve or loop in next?',
  },
  {
    id: 'risksToWatch',
    label: 'Are there any risks or blockers I should anticipate?',
  },
  {
    id: 'strategicAngle',
    label: 'How can I elevate this conversation to a strategic level?',
  }
];
